export const GET_HOUSE = 'GET_HOUSE';
